export default __webpack_public_path__ + "static/media/Dinosaurs_21.4b22386a.png";